import { c as _c } from "react/compiler-runtime";
interface CollectionLoadMoreProps {
  readonly isVisible: boolean;
  readonly isFetching: boolean;
  readonly onLoadMore: () => void;
}
export function CollectionLoadMore(t0) {
  const $ = _c(4);
  const {
    isVisible,
    isFetching,
    onLoadMore
  } = t0;
  if (!isVisible) {
    return null;
  }
  const t1 = isFetching ? "Loading..." : "Load More";
  let t2;
  if ($[0] !== isFetching || $[1] !== onLoadMore || $[2] !== t1) {
    t2 = <div className="tw-flex tw-justify-center"><button type="button" onClick={onLoadMore} disabled={isFetching} className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-transition tw-bg-iron-900 tw-text-iron-400 tw-border tw-border-solid tw-border-iron-800 desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{t1}</button></div>;
    $[0] = isFetching;
    $[1] = onLoadMore;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}